import { render, staticRenderFns } from "./ServiceDescriptionModal.vue?vue&type=template&id=2c2f4e10&"
import script from "./ServiceDescriptionModal.vue?vue&type=script&lang=js&"
export * from "./ServiceDescriptionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports